import { render, staticRenderFns } from "./BatchTrackingPage.vue?vue&type=template&id=74328fdf"
import script from "./BatchTrackingPage.vue?vue&type=script&lang=js"
export * from "./BatchTrackingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports